import React from 'react';
import Header               from './header.js';
import { withRouter }       from 'react-router';
import {Helmet} from "react-helmet";

class Layout extends React.Component {
  render() {
    let classname = '',
        path = this.props.location.pathname,
        projectRegex = RegExp('^/projects/*'), // projects
        postRegex = RegExp('^/news/*'); // post

    if(path === '/') {
      classname = 'home';
    } else if(path === '/news') {
      classname = 'news';
    }else if(projectRegex.test(path)){
      classname = 'project';
    } else if(postRegex.test(path)){
      classname = 'post';
    } else {
      classname = path.substring(1);
    }

    return (
      <div className={'content ' + classname }>
        <Helmet>
          <link rel="canonical" href={`https://moldarchitects.com${this.props.location.pathname}`} />
          <meta property="og:url" content={`https://moldarchitects.com${this.props.location.pathname}`} />
        </Helmet>
        <Header {... this.props} />
        <main role="main" className="main">
            { this.props.children }
        </main>
        <div className="lines"><div /><div /><div /></div>
        {/* <div className="curtains"><div /><div className="cnt"><div /><div /><div /></div><div /></div>*/}
      </div>
    );
  }
}

export default withRouter(Layout);



// WEBPACK FOOTER //
// ./src/scripts/components/layout.js